/**
 * Bandeau suggerant de tourner l'appareil en paysage (jeu pense pour une
 * table large, 7 colonnes) — une simple suggestion refermable, pas un
 * blocage : contrairement a une precedente version, le jeu reste jouable et
 * visible en portrait si le joueur prefere l'ignorer (cf. index.html/style.css
 * pour l'affichage, pilote en CSS pur via @media orientation).
 */
export function initRotateHint(): void {
  const closeBtn = document.getElementById("rotate-hint-close");
  const hint = document.getElementById("rotate-hint");
  closeBtn?.addEventListener("click", () => {
    hint?.setAttribute("hidden", "");
  });
}
